import {
    Component 
} from "@angular/core";

@Component({
    selector: 'mdk-mo-card-gogh',
    templateUrl: './mo-card-gogh.component.svg'
})
export class MoCardGoghComponent {}